import React, { useState, useEffect} from "react";
import { useLocation } from 'react-router-dom';
import HeroSection from "../components/HomeSection";
import InfoSection from "../components/infoSection";
import NavbarComponent from "../components/navbar/index";
import { Sidebar } from "../components/sidebar";
import Image1 from "../images/design-notes.svg";
import Image2 from "../images/space.svg";
import InfoSectionLight from "../components/infoSectionLight";
import Services from "../components/services";
import Footer from "../components/footer";
import Loader from '../components/Loader';
export const Home = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const location = useLocation();
  const toggle = () => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    setTimeout(() => setLoaded(true), 500); 
  }, []);
  const isHomePage = location.pathname === '/';
  return (
    <>
    {loaded ? (
      <>
        <Sidebar isOpen={isOpen} toggle={toggle} isHomePage={isHomePage} />
        <NavbarComponent toggle={toggle} isHomePage={isHomePage} />
        <main style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
          <HeroSection />
          <Footer />
        </main>
      </>
    ) : (
      <Loader />
    )}
  </>
  
  );
};
